/**
 * Loads Google Analytics (gtag.js) when a measurement ID is provided.
 * Intended for live/prod only — set GA_MEASUREMENT_ID in prod env files.
 */
export function initGtag(measurementId) {
  if (!measurementId) return;

  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', measurementId);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
}
